export const getOSTheme = (): 'light' | 'dark' => {
  if (typeof window === 'undefined') {
    return 'light'
  }

  const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

  return darkModeMediaQuery.matches ? 'dark' : 'light'
}

export const subscribeToOSThemeChanges = (
  callback: (theme: 'light' | 'dark') => void,
): (() => void) => {
  if (typeof window === 'undefined') {
    return () => {}
  }

  const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

  const handler = (e: MediaQueryListEvent): void => {
    callback(e.matches ? 'dark' : 'light')
  }

  darkModeMediaQuery.addEventListener('change', handler)

  return () => {
    darkModeMediaQuery.removeEventListener('change', handler)
  }
}
